function escapeHtml(value) {
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function decodeEntities(value) {
  return String(value).replace(/&(amp|lt|gt|quot|#39|#x27|#(\d+)|#x([\da-f]+));/gi, (entity, named, decimal, hexadecimal) => {
    if (decimal) return String.fromCodePoint(Number(decimal))
    if (hexadecimal) return String.fromCodePoint(parseInt(hexadecimal, 16))
    return {
      amp: '&', lt: '<', gt: '>', quot: '"', '#39': "'", '#x27': "'",
    }[String(named).toLowerCase()] || entity
  })
}

export function normalizeReplyLink(value) {
  const href = decodeEntities(value).trim()
  const hasControlCharacter = Array.from(href).some(character => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)
  if (!href || /[\\\s]/.test(href) || hasControlCharacter) return null
  if (href.startsWith('/')) return href.startsWith('//') ? null : href
  try {
    const url = new URL(href)
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return null
    return url.toString()
  } catch (_) {
    return null
  }
}

export function sanitizeReplyHtml(value) {
  const source = typeof value === 'string' ? value : ''
  const anchor = /<a\s+href=(['"])(.*?)\1\s*>([\s\S]*?)<\/a\s*>/gi
  let cursor = 0
  let output = ''
  let match = anchor.exec(source)
  while (match) {
    output += escapeHtml(source.slice(cursor, match.index))
    const href = normalizeReplyLink(match[2])
    if (!href) output += escapeHtml(match[0])
    else output += `<a href="${escapeHtml(href)}">${escapeHtml(decodeEntities(match[3]).replace(/<[^>]*>/g, ''))}</a>`
    cursor = match.index + match[0].length
    match = anchor.exec(source)
  }
  return output + escapeHtml(source.slice(cursor))
}

export function replyLinkAtSelection(value, start, end) {
  const source = typeof value === 'string' ? value : ''
  const anchor = /<a\s+href=(['"])(.*?)\1\s*>([\s\S]*?)<\/a\s*>/gi
  let match = anchor.exec(source)
  while (match) {
    const labelStart = match.index + match[0].indexOf('>') + 1
    const labelEnd = match.index + match[0].lastIndexOf('</a>')
    if (start >= labelStart && end <= labelEnd) {
      const href = normalizeReplyLink(match[2])
      if (href) {
        return {
          start: match.index, end: match.index + match[0].length, href, label: decodeEntities(match[3]).replace(/<[^>]*>/g, ''),
        }
      }
    }
    match = anchor.exec(source)
  }
  return null
}

export function buildReplyLink(label, href) {
  const normalized = normalizeReplyLink(href)
  const text = String(label || '').trim()
  if (!normalized || !text) return null
  return `<a href="${escapeHtml(normalized)}">${escapeHtml(text)}</a>`
}
